module.exports = __webpack_public_path__ + "img/pacman_bumpersticker.8213adf8.jpg";